import type { Styles } from '@adornis/ass/style.js';
import { XSidebarItem } from '@adornis/chemistry/elements/components/x-sidebar.js';
import type { PropertyValueMap } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { ChromiumLink } from './cr-link.js';

/**
 * @customElement cr-sidebar-item
 */
@customElement('cr-sidebar-item')
export class ChromiumSidebarItem extends XSidebarItem {
  @property({ type: Boolean }) indented = false;
  @property({ type: Boolean, reflect: true, attribute: true }) deactivated = false;

  override validateActive: (currentUrl: string, href?: string) => boolean = (currentUrl: string, href?: string) => {
    if (!href) return false;
    if (href === '/') return currentUrl === '/';
    return currentUrl === href;
  };

  protected override firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.firstUpdated(_changedProperties);

    const link = this.shadowRoot?.getRootNode().childNodes[2] as ChromiumLink;
    if (!link || this.deactivated === false) return;

    link.deactivated = true;
  }

  override styles() {
    return [
      {
        'cr-link': {
          opacity: this.deactivated ? 0.6 : 1.0,
          fontFamily: 'Montserrat',
          fontStyle: 'normal',
          fontWeight: '500',
          fontSize: '16px',
          color: 'white',
          lineHeight: '150%',
          transition: 'all 0.1s ease',
          padding: `${this.spacing.lg} ${this.spacing.md}`,
          backgroundImage: this.active
            ? 'linear-gradient(90deg, rgba(255, 255, 255, 0.1) 27.6%, rgba(255, 255, 255, 0) 100%)'
            : 'transparent',
          borderLeft: this.active ? 'solid 4.61px white' : 'solid 4.61px transparent',
        },
        ':host:not([deactivated]) cr-link:hover': {
          backgroundImage: 'linear-gradient(90deg, rgba(255, 255, 255, 0.1) 27.6%, rgba(255, 255, 255, 0) 100%);',
          transition: 'all 0.1s ease',
          backgroundPosition: '0 0',
        },

        'cr-icon': {
          // filter: 'invert(100%) sepia(0%) saturate(25%) hue-rotate(70deg) brightness(108%) contrast(108%)',
        },
        ':host([indented])': { marginLeft: '12px' },
        ':host([indented]) cr-link': { padding: `${this.spacing.md} ${this.spacing.xs}`, fontSize: '16px' },
        ':host([indented-large])': { marginLeft: '24px' },
        ':host([indented-large]) cr-link': { padding: `${this.spacing.lg} ${this.spacing.xs}`, fontSize: '16px' },
      } satisfies Styles,
    ];
  }
}
